import { Node_Type } from "./../../ricos-types/index.js";
import Caption from "../../_shared/figure/viewer-caption.js";
import Giphy from "./viewer-giphy.js";
const nodeViewRenderers = {
  [Node_Type.GIF]: Giphy,
  [Node_Type.CAPTION]: Caption
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
